import * as types from './types/getters';

export default {
    [types.GET_AUDIO_BOOK]: state => state.audioBook
};
